import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    icon: "fas fa-file-export",
    title: "Export to Report",
    round: "",
    flat: "",
    onClick: _ctx.openModal
  }, null, 8, ["onClick"]))
}